import React, { Fragment } from "react";

import useStore from "core/custom-hooks/useStore";

import MobileMenu from "components/Navigation/MobileMenu/MobileMenu";
import Header from "components/Navigation/Header/Header";
import Sidebar from "components/Navigation/Sidebar/Sidebar";
import Popup from "components/Popup/Popup";
import MobileHeader from "components/Navigation/MobileHeader/MobileHeader";
import Notification from "components/Notification/Notification";
import TzurPopup from "components/TzurPopup/TzurPopup";
import TzurPopupCenter from "components/TzurPopupCenter/TzurPopupCenter";

const Layout = ({ children,isActive,isRRH }) => {
    const { state } = useStore();
    const { isMobileMenuOpen } = state;

    return (
        <div id="wrapper">
            <Popup />
            <TzurPopup />
            <TzurPopupCenter/>
            <Notification/>
            <Header isPreAuthentication={false} 
            isActive={isActive}
            isRRH={isRRH}
            />

            <div className="main_content_container">
                <Fragment>
                    <Sidebar />
                    <MobileMenu />
                    <div className="content_body">
                        <MobileHeader
                        isActive={isActive}
                        isRRH={isRRH}
                        />
                        {children}
                    </div>
                </Fragment>
            </div>
            {isMobileMenuOpen && <div className="darken-mode"></div>}
        </div>
    );
};

export default Layout;
